import React from 'react'
import PropTypes from 'prop-types'

const PlusIcon = ({ className, title }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    aria-label={title}
  >
    <path
      d="M12 4.5v15m7.5-7.5h-15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

PlusIcon.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string
}

PlusIcon.defaultProps = {
  className: '',
  title: ''
}

export default PlusIcon
